import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Table,
} from "reactstrap";

import "./UserManagement.scss";

import { get, put } from "helpers/api_helper";
import * as api from "../../constants/api_constants";

import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import { charactersWithSpaces } from "helpers/validations/regex";
import OptionsMenu from "components/OptionsMenu";
import SummaryCards from "components/SummaryCards";
import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";

function Role() {
  const navigate = useNavigate();
  const [rolesData, setRolesData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const data = await get(api.GET_ROLES_DATA);
      if (data) {
        setRolesData(data?.rolePermissionPage?.content);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSwitchToggle = async (roleId) => {
    const roleToUpdate = rolesData.find((role) => role.id === roleId);
    if (!roleToUpdate) return;

    try {
      await put(api.UPDATE_ROLE_BY_ID(roleId), {
        rolePermissionDTO: {
          ...roleToUpdate,
          status: roleToUpdate.status === 1 ? 0 : 1,
        },
      });
      showSuccessToast("Role status updated successfully");
      await fetchData();
    } catch (error) {
      console.error("Error updating role status:", error);
      showErrorToast("Failed to update role status");
    }
  };

  const summaryData = [
    {
      iconClass: "fas fa-user-tag text-primary",
      label: "Total Count",
      value: rolesData.length,
    },
    {
      iconClass: "fas fa-user-check text-primary",
      label: "Active Count",
      value: rolesData.filter((role) => role.status === 1).length,
    },
    {
      iconClass: "fas fa-user-times text-danger",
      label: "In-Active Count",
      value: rolesData.filter((role) => role.status === 0).length,
    },
  ];

  return (
    <div className="page-content">
      <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
        <PageSubHeader
          heading={"User Roles"}
          routePath={"Home"}
          pageName={"Roles"}
        />
        <Row className="px-4">
          <SummaryCards data={summaryData} />

          <Row>
            <Col>
              <Row className="d-flex justify-content-between align-items-center py-2">
                <Col xs={3}>
                  <InputGroup size="sm" className="elbert-search-group">
                    <Input
                      placeholder="Search, ID, Name, Email"
                      className="elbert-search"
                    />
                    <InputGroupText>
                      <span className="fa fa-search"></span>
                    </InputGroupText>
                  </InputGroup>
                </Col>
                <Col xs={3}></Col>
                <Col
                  xs={2}
                  className="d-flex align-items-center justify-content-end"
                >
                  {/* <Button
                    color="primary"
                    outline
                    className="waves-effect waves-light"
                    onClick={() => navigate("/add-role")}
                  >
                    Add role
                  </Button> */}
                  <CustomButton
                    text={"+ Add New"}
                    onClick={() => navigate("/add-role")}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Card>
                    <CardBody>
                      {/* <CardTitle className="h4">Role</CardTitle> */}
                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <thead>
                            <tr className="d-padding-left">
                              <th>Role Name</th>
                              <th>Role ID</th>
                              <th>Status</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rolesData.map((role, index) => (
                              <tr key={index}>
                                {/* <td>
                              <OptionsMenu
                               onEdit={() =>navigate(`/add-role/${role.id}`)}
                              />
                              </td> */}
                                <td>{role.role}</td>
                                <td>{role.id}</td>
                                <td>
                                  <FormGroup switch>
                                    <Input
                                      style={{
                                        color: "blue",
                                        height: "1.4em",
                                        width: "3em",
                                        cursor: "pointer",
                                      }}
                                      type="switch"
                                      id={`role-status-${role.id}`}
                                      checked={role.status === 1 ? true : false}
                                      onChange={() =>
                                        handleSwitchToggle(role.id)
                                      }
                                    />
                                  </FormGroup>
                                </td>
                                <td>
                                  <div className="d-flex gap-3 align-items-center">
                                    <i
                                      className="fa-solid fa-eye action-icon"
                                      title="View"
                                    ></i>
                                    <i
                                      onClick={() =>
                                        navigate(`/add-role/${role.id}`)
                                      }
                                      className="fa-regular fa-pen-to-square action-icon"
                                      title="Edit"
                                    ></i>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Row>
      </Container>
    </div>
  );
}

export default Role;
